// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.case-card__container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  border-radius: 12px;
}

.case-card__header {
  text-shadow: 0 0 9px rgba(0, 0, 0, 0.81);
  color: var(--accent-color);
  font-weight: 800;
  line-height: 140%;
}

.case-card__footer {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: flex-end;
  align-items: flex-start;
}

.case-card__footer-text {
  color: var(--white-color);
  text-shadow: 0 0 9px rgba(28, 33, 46, 0.24);
}

@media only screen and (min-device-width: 320px) {
  .case-card__container {
    padding: 20px 16px;
  }
  .case-card__header {
    font-size: 20px;
    letter-spacing: 0.8px;
  }
  .case-card__footer-text {
    margin-bottom: 16px;
  }
}
@media only screen and (min-device-width: 768px) {
  .case-card__container {
    padding: 36px 44px;
  }
  .case-card__header {
    font-size: 26px;
    letter-spacing: 1.04px;
  }
  .case-card__footer-text {
    margin-bottom: 24px;
  }
}
@media only screen and (min-device-width: 992px) {
  .case-card__container {
    padding: 36px;
  }
  .case-card__header {
    font-size: 32px;
    letter-spacing: 1.28px;
  }
  .case-card__footer-text {
    margin-bottom: 24px;
  }
}
@media only screen and (min-device-width: 1366px) {
  .case-card__container {
    padding: 36px 44px;
  }
  .case-card__header {
    font-size: 32px;
    letter-spacing: 1.28px;
  }
  .case-card__footer-text {
    margin-bottom: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CaseCard/caseCard.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,wCAAA;EACA,0BAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,uBAAA;AAEF;;AAAA;EACE,yBAAA;EACA,2CAAA;AAGF;;AADA;EACE;IACE,kBAAA;EAIF;EAFD;IACG,eAAA;IACA,qBAAA;EAIF;EAFA;IACE,mBAAA;EAIF;AACF;AAFA;EACE;IACE,kBAAA;EAIF;EAFD;IACG,eAAA;IACA,sBAAA;EAIF;EAFA;IACE,mBAAA;EAIF;AACF;AADA;EACE;IACE,aAAA;EAGF;EADD;IACG,eAAA;IACA,sBAAA;EAGF;EADA;IACE,mBAAA;EAGF;AACF;AAAA;EACE;IACE,kBAAA;EAEF;EAAD;IACG,eAAA;IACA,sBAAA;EAEF;EAAA;IACE,mBAAA;EAEF;AACF","sourcesContent":[".case-card__container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  height: 100%;\n  border-radius: 12px;\n}\n\n.case-card__header {\n  text-shadow: 0 0 9px rgba(0, 0, 0, 0.81);\n  color: var(--accent-color);\n  font-weight: 800;\n  line-height: 140%;\n}\n.case-card__footer{\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: flex-end;\n  align-items: flex-start;\n}\n.case-card__footer-text {\n  color: var(--white-color);\n  text-shadow: 0 0 9px rgba(28, 33, 46, 0.24);\n}\n@media only screen and (min-device-width: 320px) {\n  .case-card__container{\n    padding: 20px 16px;\n  }\n .case-card__header{\n    font-size: 20px;\n    letter-spacing: 0.8px;\n }\n  .case-card__footer-text{\n    margin-bottom: 16px;\n  }\n}\n@media only screen and (min-device-width: 768px) {\n  .case-card__container{\n    padding: 36px 44px;\n  }\n .case-card__header{\n    font-size: 26px;\n    letter-spacing: 1.04px;\n }\n  .case-card__footer-text{\n    margin-bottom: 24px;\n  }\n}\n\n@media only screen and (min-device-width: 992px) {\n  .case-card__container{\n    padding: 36px;\n  }\n .case-card__header{\n    font-size: 32px;\n    letter-spacing: 1.28px;\n }\n  .case-card__footer-text{\n    margin-bottom: 24px;\n  }\n}\n\n@media only screen and (min-device-width: 1366px) {\n  .case-card__container{\n    padding: 36px 44px;\n  }\n .case-card__header{\n    font-size: 32px;\n    letter-spacing: 1.28px;\n }\n  .case-card__footer-text{\n    margin-bottom: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
